import DefaultCheckbox from "./default-checkbox";
import VerticalCheckbox from "./vertical-checkbox";

export default { DefaultCheckbox, VerticalCheckbox };
